export const apiBaseUrl = 'https://api.vico-tech.com/ims';

export async function request(endpoint, method, body = null) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const token = localStorage.getItem('accessToken');
    if (token) {
        headers.append('Authorization', `Bearer ${token}`);
    }

    const config = {
        method: method,
        headers: headers,
    };

    if (body) {
        config.body = JSON.stringify(body);
    }

    const response = await fetch(`${apiBaseUrl}${endpoint}`, config);

    if (!response.ok) {
        const errorData = await response.json();
        const error = new Error(errorData.error?.message || 'An unknown error occurred.');
        error.status = response.status;
        error.details = errorData.error;
        throw error;
    }

    return response.json();
}

export async function requestBlob(endpoint) {
    const headers = new Headers();
    const token = localStorage.getItem('accessToken');
    if (token) {
        headers.append('Authorization', `Bearer ${token}`);
    }
    const config = { method: 'GET', headers: headers };

    const response = await fetch(`${apiBaseUrl}${endpoint}`, config);

    if (!response.ok) {
        throw new Error('Image could not be fetched.');
    }

    return response.blob();
}